<template>
  <div>
  </div>
</template>

<script>


import { mapState } from 'vuex'
import { mapActions } from 'vuex'

  export default {
    name: 'StagePresenter',
    components: {
    },
    props: {
      packageid : String
    },
    computed: {

      ...mapState("sessionState", [
          "package"
      ]),

    },

    mounted: function () {

      if(this.package.settings.progType == "FORCEDLINEAR")
      {
        this.FindNextStage();
      }
    },
    data: () => ({

    }),
    methods: {
      ...mapActions("sessionState", [
        "FindNextStage"
      ])
    },
    watch: {
      
    }
  }
</script>
